<template>
    <div class="main-layout">
        <div class="main-layout__header">
            <slot name="header" />
        </div>
        <template v-if="!loading">
            <div class="main-layout__feature">
                <slot name="feature" />
            </div>
            <div class="main-layout__toolbar">
                <slot name="toolbar" />
            </div>
          <div class="main-layout__summary">
            <slot name="summary" />
          </div>
            <div class="main-layout__body">
                <slot name="body" />
            </div>
        </template>
        <div v-else class="loading-status">
            <v-progress-circular color="primary" size="48" indeterminate />
        </div>
        <div class="main-layout__footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
    /**
     * 메인 라우터에서 기본 레이아웃 틀을 잡아주는 컴포넌트입니다.
     *
     * 헤더, 푸터는 고정됩니다.
     */
    export default {
        name: "MainLayout",
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style scoped>
    .main-layout {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        overflow-y: hidden;
    }

    .main-layout__feature {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        margin: 0.125rem 0;
    }

    .main-layout__toolbar {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        margin: 0.125rem 0;
    }
    .main-layout__summary {
    }

    .main-layout__header {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        flex-grow: 0;
    }

    .main-layout__body {
        flex-grow: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: start;
    }

    .loading-status {
        flex-grow: 1;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .main-layout__footer {
        flex-grow: 0;
    }
</style>
